import { DateTime, Duration } from 'luxon'

type DateTimeIsh = DateTime | Date | string | null | undefined
type DurationIsh = Duration | string | null | undefined
const getDateObject = (input: DateTimeIsh) => {
    if (!input) return undefined
    if (typeof input == 'string') return DateTime.fromISO(input)
    if (input instanceof Date) return DateTime.fromJSDate(input)
    return input
}
const getDurationObject = (input: DurationIsh) => {
    if (!input) return undefined
    if (typeof input == 'string') {
        // Parse duration string
        const parts = input.split(':')
        let hours = parseInt(parts[0] ?? 0)
        let minutes = parseInt(parts[1] ?? 0)
        let seconds = parseInt(parts[2] ?? 0)
        // return 0 if NaN
        hours = isNaN(hours) ? 0 : hours
        minutes = isNaN(minutes) ? 0 : minutes
        seconds = isNaN(seconds) ? 0 : seconds
        // Return duration object
        return Duration.fromObject({ hours, minutes, seconds })
    }
    if (input instanceof Duration) return input
    return input
}
const formatTwoDigits = (num?: number) => (!num ? '00' : Math.round(num).toString().padStart(2, '0'))

const formatDate = (input?: DateTimeIsh, fallback?: string) => {
    const date = getDateObject(input)
    if (!date) return fallback ?? undefined

    return date.toLocaleString(DateTime.DATE_MED)
}
const formatDateTime = (input?: DateTimeIsh, fallback?: string) => {
    const date = getDateObject(input)
    if (!date) return fallback ?? undefined

    return date.toLocaleString(DateTime.DATETIME_MED)
}
const formatTime = (input?: DateTimeIsh, fallback?: string) => {
    const date = getDateObject(input)
    if (!date) return fallback ?? undefined

    return date.toLocaleString(DateTime.TIME_SIMPLE)
}
const formatTimeDifferenceHours = (date1?: DateTimeIsh, date2?: DateTimeIsh, fallback?: string, text?: boolean, includeSeconds: boolean = true) => {
    const date1Obj = getDateObject(date1)
    const date2Obj = getDateObject(date2)
    if (!date1Obj || !date2Obj) return fallback ?? undefined
    const diff = date1Obj.diff(date2Obj, ['hours', 'minutes', 'seconds'])
    return formatTimeDifferenceHoursFromDuration(diff, undefined, text, includeSeconds)
}
const formatTimeDifferenceHoursFromDuration = (duration?: DurationIsh, fallback?: string, text?: boolean, includeSeconds: boolean = true) => {
    const diff = getDurationObject(duration)?.toObject()
    if (!diff) return fallback ?? undefined
    return text ?
        [
            diff.hours ? diff.hours + ' hrs' : null,
            (diff.minutes || !includeSeconds) ? diff.minutes + ' mins' : null,
            (includeSeconds && diff.seconds) ? diff.seconds + ' s' : null
        ].filter(Boolean).join(' ') :
        (diff.hours ? diff.hours + ':' : '') + formatTwoDigits(diff.minutes) + ':' + formatTwoDigits(diff.seconds)
}
const formatDateInput = (input?: DateTimeIsh, fallback?: string) => {
    const date = getDateObject(input)
    if (!date) return fallback ?? undefined
    const str = date.toISODate()
    if (!str) return fallback ?? undefined
    return str
}
const formatDateTimeInput = (input?: DateTimeIsh, fallback?: string) => {
    const date = getDateObject(input)
    if (!date) return fallback ?? undefined
    const str = date.toISO()?.slice(0, 16)
    if (!str) return fallback ?? undefined
    return str
}
export {
    formatDate,
    formatDateInput,
    formatDateTime,
    formatDateTimeInput,
    formatTime,
    formatTimeDifferenceHours,
    formatTimeDifferenceHoursFromDuration,
    getDurationObject
}

